// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyrightOutlinedSvg from "@fishx/icons-svg/es/asn/CopyrightOutlined";
import FishxIcon from '../components/FishxIcon';

var CopyrightOutlined = function CopyrightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightOutlinedSvg
  }));
};

CopyrightOutlined.displayName = 'CopyrightOutlined';
export default React.forwardRef(CopyrightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CopyrightOutlined.js
// module id = 2333
// module chunks = 0